import React from "react";
import UseSquadflixNavigate from "../useSquadflixNavigate";
import ItemsHorizontalScroll from "../../shared/itemsHorizontalScroll/itemsHorizontalScroll";
import ItemBackdropDetails from "../../shared/item-backdrop-details/item-backdrop-details";
import {countItemTotalSeasons, getSerieDates, getYearOfDate} from "../../../../utils/utils";
import './collections-items-row.scss';
import auth from "../../../../utils/authentication";
import SquadflixRowTitle from "../squadflixRowTitle/squadflixRowTitle";
import {useCollectionItemsData} from "../../hooks/useCatalogRowData";

type Props = SquadflixRowsBaseProps & {
    onMovieClick?: (item: any) => void;
    onSerieClick?: (item: any) => void;
    collectionId: string;
    header?: {
        title: React.ReactNode;
        iconClass: string;
    };
    canHide?: boolean;
    onHide?: () => void;
    canEdit?: boolean;
}

const CollectionsItemsRow = (props: Props) => {
    const {onMovieClick, collectionId, header, onSerieClick, canHide, onHide, canEdit} = props;
    const {
        items: viewLaterItems,
        collectionInfo,
        initialLoading,
        loadNextPage: handleLoadNextPage
    } = useCollectionItemsData(collectionId);
    const squadflixNav = UseSquadflixNavigate({});

    const handleClickPoster = (item) => {
        if (item.isMovie) {
            onMovieClick ? onMovieClick(item) : squadflixNav.navigateToMovie(item);
        } else {
            onSerieClick ? onSerieClick(item) : squadflixNav.navigateToSerie(item);
        }
    }

    if (initialLoading) return null;
    if (!viewLaterItems || viewLaterItems.length === 0) return null;
    return (
        <div style={{height: "fit-content", overflow: "hidden", order: props.order ?? 0}}>
            <SquadflixRowTitle
                {...props}
                extraOptions={
                    <>
                        {canEdit && collectionInfo.uid === auth.currentUser.uid &&
                            <button className="collections-items-row__hide-btn" onClick={() => {
                                squadflixNav.navigateToCollectionDetails(collectionInfo);
                            }}>
                                <i className="fa-solid fa-pencil"></i>
                            </button>}
                        {canHide && <button className="collections-items-row__hide-btn" onClick={onHide}>
                            <i className="fa-solid fa-minus"></i>
                        </button>}
                    </>
                }
                title={typeof header.title == "string" ? header.title.replace("{{collectionName}}", collectionInfo.name) : header.title}
                icon={<i className={header.iconClass}></i>}
            />

            <ItemsHorizontalScroll onScrollEnd={handleLoadNextPage}>

                <div className="d-flex flex-row gap-3"
                     style={{paddingLeft: "13px", paddingTop: "13px", paddingRight: "13px"}}>
                    {viewLaterItems.map((item) => {
                        const numberOfSeasons = item.isMovie ? 0 : countItemTotalSeasons(item);
                        return (<div key={item.id}>
                            <ItemBackdropDetails
                                onClickPoster={() => handleClickPoster(item)}
                                onClickDetails={() => handleClickPoster(item)}
                                style={{
                                    width: "min(300px, 59vw)",
                                    position: "relative",
                                }}
                                overlay={{
                                    topLeft: item.view && <>Visto <i className="fa-solid fa-eye"></i></>,
                                    topRight: <>
                                        {item.vote_average.toFixed(1)}
                                        <i className="fa-solid fa-star fa-sm text-warning ps-1"></i>
                                    </>,
                                }}
                                tmdbSrc={item.poster_path}
                                aspectRatio={"6/9"}
                                detailsInfo={
                                    <>
                                        {item.isMovie ? <>
                                            {getYearOfDate(item.release_date)} • {item.runtime} mins
                                        </> : <>
                                            {getSerieDates(item)} • {numberOfSeasons} {numberOfSeasons === 1 ? "temporada" : "temporadas"}
                                        </>}
                                    </>}
                                detailsTitle={item.name ?? item.title}
                                detailsSubtitle={
                                    <>

                                    </>
                                }
                            />
                        </div>)
                    })}
                </div>
            </ItemsHorizontalScroll>
        </div>
    );
};

export default CollectionsItemsRow;
